module.exports = __webpack_public_path__ + "media/newstyle/images/new-icon-linkedin-ddae2c287cf3bd7a1bcc6d95f85b6054.svg";